import { pipe, prop } from 'ramda';

import { IRootState } from '../../../../store/root.types';

const pathToStatusesState = (state: IRootState) => state.recipient.statuses;

export const getIsLoaded = pipe(pathToStatusesState, state => state.isLoaded);

export const getStatuses = pipe(pathToStatusesState, state => state.statuses);

export const getHasMeeting = pipe(getStatuses, state => state.meeting);
export const getHasAddress = pipe(getStatuses, state => state.address);
export const getHasActions = pipe(getStatuses, state => state.actions);
export const getHasExchange = pipe(getStatuses, state => state.exchange);
export const getIsPreview = pipe(getStatuses, state => state.preview);
export const getIsDraft = pipe(getStatuses, state => state.draft);
export const getHasIntegration = pipe(getStatuses, state => state.hasIntegration);
export const getIsInternational = pipe(getStatuses, state => state.international);
export const getHasDeclaredData = pipe(getStatuses, state => state.declaredData);
export const getDeclaredDataMinimumProductQuantity = pipe(getStatuses, prop('declaredDataMinimumProductQuantity'));
export const getHasCustomMarketplace = pipe(getStatuses, state => state.hasCustomMarketplace);
export const getIsActivate = pipe(getStatuses, state => state.activate);
export const getOneTimeCodeVerification = pipe(getStatuses, state => state.oneTimeCodeVerification);
export const getMaxVerificationAttemptReached = pipe(getStatuses, state => state.maxVerificationAttemptReached);
export const getWhiteLabeling = pipe(getStatuses, state => state.whiteLabeling);

export const getErrors = pipe(pathToStatusesState, state => state.errors);
